import * as qs from 'qs';
import {clearVirtualProducts} from '../store/actions/options';
import {API} from './API';

export class VirtualProductService {
  async getTableProducts(params, additional = {}) {
    const [query, page, length] = API.getTableParams(params, additional);
    return this.getProducts(query, page, length);
  }

  async getProducts(query, page, length) {
    return (await API.getConnection())
      .get('virtual-products', {
        params: {...query, ...{page, length}},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data)
      .catch(error => API.handleError(error));
  }

  async getProduct(id, archive = false) {
    return (await API.getConnection())
      .get(`virtual-products/${id}`, {
        params: archive ? {filter: {archive: 'only'}} : {},
        paramsSerializer: params => qs.stringify(params),
      })
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }

  async saveProduct(product) {
    let data = product;
    let method = 'post';
    let url = 'virtual-products';
    if (product.id) {
      method = 'put';
      url = `virtual-products/${product.id}`;
    }
    return (await API.getConnection())
      [method](url, data)
      .then(response => {
        API.store.dispatch(clearVirtualProducts());
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }

  async deleteProduct(id) {
    return (await API.getConnection())
      .delete(`virtual-products/${id}`)
      .then(response => {
        API.store.dispatch(clearVirtualProducts());
        return response;
      })
      .catch(error => API.handleError(error));
  }

  async restoreProduct(id) {
    return (await API.getConnection())
      .put(`virtual-products/${id}/restore`)
      .then(response => {
        API.store.dispatch(clearVirtualProducts());
        return response.data.data;
      })
      .catch(error => API.handleError(error));
  }
}
